export const rootStoreConstant = {
    action: {
        setSignalRBulbColor: "setSignalRBulbColor",
        setSignalrConnectionStatus: "setSignalrConnectionStatus",
        setAccountNotExistStatus: "setAccountNotExistStatus",
        setEmailConfigurationExist: "setEmailConfigurationExist",
        getCustomDomainConfiguration: "getCustomDomainConfiguration",
    },
    mutation: {
        SET_SIGNALR_BULB_COLOR: "SET_SIGNALR_BULB_COLOR",
        SET_CURRENT_VERSION: "SET_CURRENT_VERSION",
        SET_EMAIL_CONFIGURATIONS_EXIST: "SET_EMAIL_CONFIGURATIONS_EXIST",
    },
    getter: {
        getSignalRBulbColor: "getSignalRBulbColor",
        getEmailConfigurationExist: "getEmailConfigurationExist",
        getCurrentVersion: "getCurrentVersion",
        GetTechnician: "getTechnician"
    },
};
